import Label from '../Label';
import * as Styled from './CompositionDetail.styles';

interface CompositionDetailProps {
  label: string;
  value: string;
}

const CompositionDetail = ({ label, value }: CompositionDetailProps) => (
  <Styled.Card
    title={<Label>{label}</Label>}
    headStyle={{
      backgroundColor: 'rgb(203, 223, 242)',
      borderRadius: '8px 8px 0 0',
    }}
    bodyStyle={{
      padding: '8px',
    }}
  >
    {value}
  </Styled.Card>
);

export default CompositionDetail;
